import { getTracker } from '../tracker';
const initialState = {
  validatingAuthToken: false,
};

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'VALIDATING_AUTH_TOKEN': {
      return Object.assign({}, state, {
        validatingAuthToken: action.payload,
      });
    }
    case 'LOGIN_FAILURE': {
      return Object.assign({}, state, {
        authenticated: false,
        error: action.payload.error,
      });
    }
    case 'LOGIN_SUCCESS': {
      let values = action.payload;
      getTracker().track(action.type, values);
      getTracker().identify(values.user);
      return Object.assign({}, state, {
        authenticated: true,
        ...values,
        error: undefined,
      });
    }
    case 'RESET_PASSWORD_SUCCESS': {
      let values = action.payload;

      return Object.assign({}, state, {
        resetPasswordSuccess: values.success,
        error: undefined,
      });
    }
    case 'FORGOT_PASSWORD_SUCCESS': {
      return { ...state, forgotPassSuccess: true };
    }
    case 'TOKEN_VALID': {
      return { ...state, tokenValid: true, error: undefined };
    }
    case 'TOKEN_INVALID': {
      return { ...state, tokenValid: false };
    }
    case 'AUTH_ERROR': {
      return Object.assign({}, state, { error: action.payload.error });
    }
    case 'LOGOUT': {
      getTracker().track(action.type, { user: state.user });
      return Object.assign({}, { authenticated: false, error: undefined });
    }
    // case 'INITIALIZE': {
    //   let token = localStorage.getItem('token');
    //   if (token) {
    //     try {
    //       let userDetails = JSON.parse(atob(token.split('.')[1]));
    //       getTracker().identify(userDetails.user);
    //       getTracker().track('LOGIN_SUCCESS', userDetails);
    //       if (userDetails)
    //         return Object.assign({}, state, {
    //           authenticated: true,
    //           ...userDetails,
    //         });
    //     } catch (err) {
    //       console.log(err.message);
    //     }
    //   }
    //   return state;
    // }
    default: {
      return state;
    }
  }
};
export default authReducer;
